import { useSelector } from "react-redux";
import { CASE_STAGE_STATUS } from "../common/Constant";
import { RootState } from "../redux/Store";

export const useIsStageReadOnly = (): boolean => {
  const stageName = useSelector((state: RootState) => state.caseStages.currentStage);
  if (!stageName) return false;

  const normalizedStage = stageName.trim();

  const readOnlyKeywords = [CASE_STAGE_STATUS.CLOSED, CASE_STAGE_STATUS.CANCELLED, CASE_STAGE_STATUS.ONHOLD, CASE_STAGE_STATUS.ARCHIVED, "On Hold", "Cancelled", "Close", "Archive"];
  const editableKeywords = [CASE_STAGE_STATUS.NEW, CASE_STAGE_STATUS.REGISTERED];

  if (readOnlyKeywords.some(keyword => normalizedStage.includes(keyword))) {
    return true;
  }

  return false;
}
